/* Romanian presentation for the existing Easify widget; option names/values
   and the application's validation and upload behaviour remain app-owned. */
(function () {
  var translations = {
    'Add files': 'Adaugă fișiere',
    'Select a date': 'Alege o dată',
    'This is a required field': 'Acest câmp este obligatoriu',
    'Uploading...': 'Se încarcă...',
    'Remove': 'Elimină',
    'File': 'Fișier',
    'Enter your discount here': 'Introdu codul de reducere',
    'Apply': 'Aplică',
    'Sort by': 'Sortează după',
    'Please select': 'Alege o opțiune',
    'Month': 'Lună', 'Year': 'An',
    'January': 'Ianuarie', 'February': 'Februarie', 'March': 'Martie',
    'April': 'Aprilie', 'May': 'Mai', 'June': 'Iunie',
    'July': 'Iulie', 'August': 'August', 'September': 'Septembrie',
    'October': 'Octombrie', 'November': 'Noiembrie', 'December': 'Decembrie',
    'Sun': 'Dum', 'Mon': 'Lun', 'Tue': 'Mar', 'Wed': 'Mie',
    'Thu': 'Joi', 'Fri': 'Vin', 'Sat': 'Sâm'
  };
  function translateWidget(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && node.parentElement.closest('script, style, textarea')) continue;
      var text = node.nodeValue.trim();
      if (translations[text] && translations[text] !== text) node.nodeValue = node.nodeValue.replace(text, translations[text]);
      else if (text.indexOf('Your selections will add an additional charge of') === 0) node.nodeValue = node.nodeValue.replace('Your selections will add an additional charge of', 'Opțiunile selectate adaugă un cost suplimentar de');
      else if (/^File\s/.test(text)) node.nodeValue = node.nodeValue.replace(/File(?=\s)/, "Fișier");
    }
    root.querySelectorAll('[aria-label]').forEach(function (element) {
      var label = element.getAttribute('aria-label');
      var translated = translations[label];
      if (!translated && root.classList.contains('flatpickr-calendar')) {
        translated = label.replace(/^[A-Za-z]+(?= \d)/, function (month) { return translations[month] || month; });
      }
      if (translated && translated !== label) element.setAttribute('aria-label', translated);
    });
    root.querySelectorAll('[placeholder]').forEach(function (input) {
      var value = input.getAttribute('placeholder');
      if (translations[value]) input.setAttribute('placeholder', translations[value]);
    });
  }
  var queued = false;
  function update() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('.easify-product-options, .tpo-discount-code-input--input-container, .jdgm-sort-dropdown-wrapper').forEach(translateWidget);
      if (document.querySelector('.easify-product-options')) {
        document.querySelectorAll('.flatpickr-calendar').forEach(translateWidget);
      }
    });
  }
  new MutationObserver(update).observe(document.body, {childList: true, subtree: true, characterData: true});
  update();
})();
